<template>
    <div class="grid">
        <div class="col-12">
            <div class="card" v-if="permission?.includes('read')">
                <Toast />
                <Error :errors="errors" />

                <Fieldset legend="Filter" :toggleable="true" :collapsed="true" class="mb-3">
                    <Filter @submit="getDataTable()" ref="filter" />
                </Fieldset>

                <DataTable :value="dataTable" responsiveLayout="scroll" :loading="loading" dataKey="number"
                    @sort="onSort($event)" :resizableColumns="true">
                    <template #header>
                        <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                            <div>
                                <Button :loading="loadingExcel" label="Export Excel" icon="pi pi-file-excel"
                                    class="p-button p-button-success mr-2 my-1 inline-block"
                                    @click="exportExcelCSV('xlsx')" />
                                <Button :loading="loadingCsv" label="Export CSV" icon="pi pi-file-excel"
                                    class="p-button p-button-success mr-2 my-1 inline-block"
                                    @click="exportExcelCSV('csv')" />
                            </div>
                            <span class="block mt-2 md:mt-0 p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText v-model="search" placeholder="Cari..." @keyup.enter="getDataTable" />
                            </span>
                        </div>
                    </template>
                    <Column field="number" header="No." :style="{ width: '20px' }">
                        <template #body="slotProps">
                            {{ slotProps.data.number }}
                        </template>
                    </Column>
                    <Column field="region_name" header="Region">
                        <template #body="slotProps">
                            {{ slotProps.data.region_name }}
                        </template>
                    </Column>
                    <Column field="user_level" header="User Level">
                        <template #body="slotProps">
                            {{ slotProps.data.user_level }}
                        </template>
                    </Column>
                    <Column field="user_code" header="ASM Code">
                        <template #body="slotProps">
                            {{ slotProps.data.user_code }}
                        </template>
                    </Column>
                    <Column field="user_name" header="ASM Name">
                        <template #body="slotProps">
                            {{ slotProps.data.user_name }}
                        </template>
                    </Column>
                    <Column field="permit_type" header="Absence Type">
                        <template #body="slotProps">
                            {{ slotProps.data.permit_type }}
                        </template>
                    </Column>
                    <Column field="permit_date" header="Absence Date">
                        <template #body="slotProps">
                            {{ slotProps.data.permit_date }}
                        </template>
                    </Column>
                    <Column field="created_at" header="Time Input">
                        <template #body="slotProps">
                            {{ slotProps.data.created_at }}
                        </template>
                    </Column>
        

                    <template #empty> No data found. </template>
                    <template #loading> Loading data. Please wait. </template>
                    <template #footer>
                        In total there are {{ totalItemsCount ? totalItemsCount : 0 }} data.
                    </template>
                </DataTable>

                <Paginator v-model:rows="rows" v-model:first="offset" :totalRecords="totalItemsCount"
                    :rowsPerPageOptions="[10, 20, 30]">
                    <template>
                        {{ totalItemsCount }}
                    </template>
                </Paginator>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { numberingDatatable } from "../../utils/helpers";
import Filter from "../../components/report/absence/Filter.vue";
import Error from "../../components/Error.vue";

export default {
    components: {
        Filter: Filter,
        Error: Error,
    },
    data() {
        return {
            // loading
            loading: false,
            loadingExcel: false,
            loadingCsv: false,

            //datatables
            data: null,
            dataTable: null,
            rows: 10,
            search: null,
            offset: null,
            field: null,
            sort: null,
            page: null,
            totalItemsCount: 0,
        };
    },
    mounted() {
        const waitForRef = setInterval(() => {
            if (this.$refs.filter) {
                clearInterval(waitForRef);
                this.getDataTable();
            }
        }, 100);
        this.$store.commit("setErrors", {});
    },
    watch: {
        offset() {
            this.getDataTable();
        },
        rows() {
            this.getDataTable();
        },
    },
    computed: {
        ...mapGetters(["errors"]),
        ...mapGetters("auth", ["permission"]),
    },
    methods: {
        formatDate(value) {
            if (value) {
                return moment.utc(value).format("DD-MM-YYYY");
            }
        },
        // DATATABLE
        getDataTable() {
            this.loading = true;
            if (this.$refs?.filter) {
                this.$refs.filter.loading = true;
            }
            this.page = this.offset / this.rows + 1;

            this.axios({
                method: "GET",
                url: process.env.VUE_APP_ROOT_API + "web/report-absence",
                params: {
                    search: this.search,
                    per_page: this.rows,
                    page: this.page,
                    order_by: this.field,
                    sort_by: this.sort,
                    region_id: this.$refs?.filter?.filters.region_id,
                    permit_type: this.$refs?.filter?.filters.permit_type,
                    user_code: this.$refs?.filter?.filters.user_code,
                    start_date: this.$refs?.filter?.period_start_label,
                    end_date: this.$refs?.filter?.period_end_label,
                },
            })
                .then((res) => {
                    this.data = res.data.data.data;
                    this.dataTable = numberingDatatable(
                        res.data.data.data,
                        this.page,
                        this.rows
                    );
                    this.totalItemsCount = res.data.data.total;
                    this.rows = parseInt(res.data.data.per_page);
                    this.loading = false;
                    this.$refs.filter.loading = false;
                })
                .catch((err) => {
                    console.log(err);
                    this.loading = false;
                    this.$refs.filter.loading = false;
                });
        },
        onSort(event) {
            this.field = event.sortField;
            this.sort = event.sortOrder == "1" ? "ASC" : "DESC";
            this.getDataTable();
        },
        // EXPORT
        exportExcelCSV(ext) {
            if (
                this.$refs?.filter?.period_start_label !== null &&
                this.$refs?.filter?.period_end_label !== null &&
                this.$refs?.filter?.period_start_label !== "Invalid date" &&
                this.$refs?.filter?.period_end_label !== "Invalid date"
            ) {
                if (ext == "xlsx") {
                    this.loadingExcel = true;
                } else if (ext == "csv") {
                    this.loadingCsv = true;
                }

                this.axios({
                    method: "GET",
                    url: process.env.VUE_APP_ROOT_API + "web/report-absence/export",
                    responseType: "blob",
                    params: {
                        ext: ext,
                        region_id: this.$refs?.filter?.filters.region_id,
                        permit_type: this.$refs?.filter?.filters.permit_type,
                        user_code: this.$refs?.filter?.filters.user_code,
                        start_date: this.$refs?.filter?.period_start_label,
                        end_date: this.$refs?.filter?.period_end_label,
                    },
                })
                    .then((response) => {
                        let fileUrl = window.URL.createObjectURL(response.data);
                        let fileLink = document.createElement("a");

                        fileLink.href = fileUrl;

                        fileLink.setAttribute("download", "Report Absence Export." + ext);

                        document.body.appendChild(fileLink);

                        fileLink.click();

                        if (ext == "xlsx") {
                            this.loadingExcel = false;
                        } else if (ext == "csv") {
                            this.loadingCsv = false;
                        }
                    })
                    .catch((err) => {
                        console.log(err);

                        if (ext == "xlsx") {
                            this.loadingExcel = false;
                        } else if (ext == "csv") {
                            this.loadingCsv = false;
                        }
                    });
            } else {
                alert("Pastikan rentang waktu sudah benar atau tidak kosong");
            }
        },
    },
};
</script>
